/**
 * Título/subtítulo por panel (D1 follow-up, review-ea4f2a93a19e6939 finding
 * 8 / live smoke): el login que se ve en /admin antes de autenticar
 * debe reflejar el panel pedido, no siempre decir "Panel Staff" — mismo
 * criterio que `PANEL_TITLES` en AdminShell.js.
 */
const LOGIN_TITLES = { staff: 'Panel Staff', admin: 'Panel Admin' };
const LOGIN_SUBTITLES = {
    staff: 'Ingresá con tu cuenta de staff para continuar.',
    admin: 'Ingresá con tu cuenta de administrador para continuar.',
};

/**
 * Formulario de login del panel de staff (/staff) o admin (/admin).
 * Función de render pura: devuelve un string HTML, sin estado ni efectos. Los
 * datos-acción los cablea js/admin.js (setupAdminListeners).
 *
 * @param {'staff'|'admin'} [panel='staff'] — panel pedido (D1): decide qué título/subtítulo se muestra.
 * @returns {string} HTML del formulario de login.
 */
export const LoginForm = (panel = 'staff') => `
    <div class="max-w-sm mx-auto">
        <div class="flex flex-col items-center mb-8">
            <div class="w-14 h-14 rounded-2xl bg-brand/10 flex items-center justify-center mb-5">
                <i class="fa-solid fa-lock text-brand text-xl"></i>
            </div>
            <h2 class="text-2xl font-black uppercase tracking-tight text-text-primary mb-2">${LOGIN_TITLES[panel] ?? LOGIN_TITLES.staff}</h2>
            <p class="text-xs text-text-muted text-center">${LOGIN_SUBTITLES[panel] ?? LOGIN_SUBTITLES.staff}</p>
        </div>
        <form id="admin-login-form" class="flex flex-col gap-5" novalidate>
            <div>
                <label for="admin-email" class="block text-[10px] font-black text-text-muted uppercase mb-3 ml-2">Email</label>
                <input id="admin-email" name="email" type="email" inputmode="email" autocomplete="username"
                    placeholder="staff@panache.com" required
                    class="w-full bg-surface border border-border-subtle rounded-2xl py-4 px-6 text-text-primary focus:outline-none focus:border-brand font-medium">
            </div>
            <div>
                <label for="admin-password" class="block text-[10px] font-black text-text-muted uppercase mb-3 ml-2">Contraseña</label>
                <input id="admin-password" name="password" type="password" autocomplete="current-password"
                    placeholder="••••••••" required
                    class="w-full bg-surface border border-border-subtle rounded-2xl py-4 px-6 text-text-primary focus:outline-none focus:border-brand font-medium">
            </div>
            <button type="submit" data-action="admin-login"
                class="mt-2 w-full py-5 bg-brand text-white rounded-2xl font-black uppercase tracking-widest text-xs shadow-lg active:scale-95 transition-transform flex items-center justify-center gap-3 disabled:opacity-60 disabled:pointer-events-none">
                <i class="fa-solid fa-right-to-bracket" aria-hidden="true"></i>
                Ingresar
            </button>
        </form>
    </div>
`;
